import styled from 'styled-components';
import { ui } from './tokens';

// Dark rounded bar used for the top canvas nav and the drawing tools
// ("Nav Top Canvas" / "Drawing Tools" in the style guide).
export const Bar = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-around;
	width: 100%;
	background-color: ${ui.bar};
	border-radius: 12px;
	padding: 10px 6px 8px;
	font-family: ${ui.font};
	user-select: none;
	-webkit-user-select: none;
`;

export const BarDivider = styled.div`
	width: 1px;
	align-self: stretch;
	margin: 2px 0;
	background-color: ${ui.divider};
`;

type BarButtonProps = {
	icon: string;
	label: string;
	onClick: () => void;
	disabled?: boolean;
	active?: boolean;
	iconSize?: number;
};

/** Icon with a Poppins Bold uppercase label underneath (style guide: Bold 12px, #a6a6a6). */
export function BarButton({ icon, label, onClick, disabled, active, iconSize = 28 }: BarButtonProps) {
	return (
		<ButtonEl type="button" onClick={disabled ? undefined : onClick} disabled={disabled} aria-label={label} aria-pressed={active}>
			<img src={icon} alt="" width={iconSize} height={iconSize} draggable={false} />
			<ButtonLabel $active={!!active}>{label}</ButtonLabel>
		</ButtonEl>
	);
}

const ButtonEl = styled.button`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	background: none;
	border: none;
	padding: 0 2px;
	cursor: pointer;
	-webkit-tap-highlight-color: transparent;

	&:disabled {
		opacity: 0.35;
		cursor: not-allowed;
	}
`;

const ButtonLabel = styled.span<{ $active: boolean }>`
	font-family: ${ui.font};
	font-size: 9px;
	font-weight: 700;
	line-height: 1.15;
	text-transform: uppercase;
	text-align: center;
	color: ${props => (props.$active ? ui.gold : ui.label)};
	white-space: pre-line;
`;
